export default __webpack_public_path__ + "static/media/yearn-logo.84f90044.svg";